"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
//@ts-ignore
require("../theme.ts");
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Pagination.prototype.beforeRender = function () {
        this.pageNum = Math.ceil(this.props.total / this.props.pageSize);
    };
    Pagination.prototype.installed = function () {
        this.addEventListener('change', function (evt) {
            this.setAttribute('current-page', evt.detail);
        });
    };
    Pagination.prototype.goto = function (index) {
        this.props.currentPage = index;
        this.fire('change', index);
        this.update();
    };
    Pagination.prototype.render = function (props) {
        var arr = [];
        var interval = this.getInterval();
        if (interval[0] > 0 && props.numEdge > 0) {
            var end = Math.min(props.numEdge, interval[0]);
            for (var i = 0; i < end; i++) {
                arr.push(this.getItem(i, i + 1));
            }
            if (props.numEdge < interval[0] && props.ellipseText) {
                arr.push(omi_1.h("li", { class: "m-icon more btn-quicknext m-icon-more" }));
            }
        }
        for (var i = interval[0]; i < interval[1]; i++) {
            arr.push(this.getItem(i, i + 1));
        }
        if (interval[1] < this.pageNum && props.numEdge > 0) {
            if (this.pageNum - props.numEdge > interval[1] && props.ellipseText) {
                arr.push(omi_1.h("li", { class: "m-icon more btn-quicknext m-icon-more" }));
            }
            var begin = Math.max(this.pageNum - props.numEdge, interval[1]);
            for (var i = begin; i < this.pageNum; i++) {
                arr.push(this.getItem(i, i + 1));
            }
        }
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'm-pagination is-background')),
            props.prevShow && this.getPrev(),
            ' ',
            omi_1.h("ul", { class: "m-pager" }, arr.map(function (p) {
                return p;
            })),
            ' ',
            props.nextShow && this.getNext()));
    };
    Pagination.prototype.getInterval = function () {
        var ne_half = Math.ceil(this.props.numDisplay / 2);
        var upper_limit = this.pageNum - this.props.numDisplay;
        var start = this.props.currentPage > ne_half
            ? Math.max(Math.min(this.props.currentPage - ne_half, upper_limit), 0)
            : 0;
        var end = this.props.currentPage > ne_half
            ? Math.min(this.props.currentPage + ne_half, this.pageNum)
            : Math.min(this.props.numDisplay, this.pageNum);
        return [start, end];
    };
    Pagination.prototype.getPrev = function () {
        var _this = this;
        if (this.props.currentPage === 0) {
            return (omi_1.h("button", { type: "button", class: "btn-prev", disabled: true },
                omi_1.h("svg", { viewBox: "64 64 896 896", class: "", "data-icon": "left", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true" },
                    omi_1.h("path", { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" }))));
        }
        return (omi_1.h("button", { type: "button", class: "btn-prev", onClick: function (e) {
                _this.goto(_this.props.currentPage - 1);
            } },
            omi_1.h("svg", { viewBox: "64 64 896 896", class: "", "data-icon": "left", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true" },
                omi_1.h("path", { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" }))));
    };
    Pagination.prototype.getNext = function () {
        var _this = this;
        if (this.props.currentPage === this.pageNum - 1) {
            return (omi_1.h("button", { type: "button", class: "btn-next", disabled: true },
                omi_1.h("svg", { viewBox: "64 64 896 896", class: "", "data-icon": "right", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true" },
                    omi_1.h("path", { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z" }))));
        }
        return (omi_1.h("button", { type: "button", class: "btn-next", onClick: function (e) {
                _this.goto(_this.props.currentPage + 1);
            } },
            omi_1.h("svg", { viewBox: "64 64 896 896", class: "", "data-icon": "right", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true" },
                omi_1.h("path", { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z" }))));
    };
    Pagination.prototype.getItem = function (pageIndex, text) {
        var _this = this;
        if (this.props.currentPage === pageIndex) {
            return omi_1.h("li", { class: "number active" }, text);
        }
        return (omi_1.h("li", { class: "number", onClick: function (e) {
                _this.goto(pageIndex);
            } }, text));
    };
    Pagination.css = css;
    Pagination.defaultProps = {
        total: 0,
        pageSize: 10,
        numDisplay: 5,
        currentPage: 0,
        numEdge: 3,
        linkTo: '#',
        prevText: 'Prev',
        nextText: 'Next',
        ellipseText: '...',
        prevShow: true,
        nextShow: true
    };
    Pagination.propTypes = {
        total: Number,
        pageSize: Number,
        numDisplay: Number,
        currentPage: Number,
        numEdge: Number,
        linkTo: String,
        prevText: String,
        nextText: String,
        ellipseText: String,
        prevShow: Boolean,
        nextShow: Boolean
    };
    Pagination = __decorate([
        omi_1.tag('m-pagination')
    ], Pagination);
    return Pagination;
}(omi_1.WeElement));
exports.default = Pagination;
